import { render, staticRenderFns } from "./SelectorRegion.vue?vue&type=template&id=02baa408&"
import script from "./SelectorRegion.vue?vue&type=script&lang=js&"
export * from "./SelectorRegion.vue?vue&type=script&lang=js&"
import style0 from "./SelectorRegion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports